import { AppMetadataPanel } from '@kw/quokka-ui';
import _ from 'lodash';
import fileSize from 'filesize';
import { Dispatch, SetStateAction } from 'react';
import { AppDetailsType, AppAnalysisType } from './types/ApplicationDetailsType';
import { formatManagementDisplay } from '../../../utils/formatManagementDisplay';

export const MetadataPanel = ({
  isOpen,
  setIsOpen,
  appDetails,
  appAnalysis,
}: {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  appDetails: AppDetailsType;
  appAnalysis: AppAnalysisType;
}) => {
  const appInfo = {
    name: appDetails?.appName,
    platform: appDetails?.os,
    version: appDetails?.version,
    versionCode: appDetails?.versionCode,
    minSdk: appDetails?.minOsVersion,
    targetSdk: null,
    fileSize: appDetails?.size ? fileSize(appDetails?.size) : '',
    submissionDate: appAnalysis?.dateSubmitted,
    submissionTag: `App Type - ${formatManagementDisplay(appAnalysis?.management)}`,
    sha1: null,
    md5: null,
    substitutedVersion: appDetails?.analyzedVersion,
  };

  const marketInfo = {
    category: appDetails?.categories?.map(category => _.capitalize(category)).join(', ') || '',
    storeUrl: appDetails?.storeUrl,
    developer: appDetails?.developerName,
    developerUrl: appDetails?.developerUrl,
    privacyPolicy: appDetails?.privacyPolicyUrl,
  };

  return (
    <AppMetadataPanel
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      appInfo={appInfo}
      marketInfo={marketInfo}
      certificateInfo={{}}
      showDownloads={false}
    />
  );
};
